exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* LOGIN SECTION STYLES\n*/.SectionLogin .block-forgot-password{line-height:24px;margin-top:20px}.SectionLogin form fieldset{margin-top:2em}.SectionLogin form fieldset #login-btn,.SectionLogin form fieldset #register-btn{display:block;width:100%}.SectionLogin form fieldset #login-btn{margin-top:2em;margin-bottom:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./customer/sections/auth/login.useable.scss
// module id = 724
// module chunks = 0